import { Product } from "@/contexts/ComparisonContext";
import ordna_bolan from '@/assets/ordna_bolan.png';

export const topPrivateLoans: Product[] = [
  {
    id: '1',
    provider: 'Bank Norwegian',
    logo: '/placeholder.svg',
    rate: '4.95%',
    amount: '5 000 - 600 000 kr',
    features: ['Ingen uppläggningsavgift', 'Svar inom 24h hos långivaren', 'Jämför utan UC', 'Betala tillbaka när du vill'],
    rating: 4.8,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: '2',
    provider: 'Sambla',
    logo: '/placeholder.svg',
    rate: '5.45%',
    amount: '10 000 - 500 000 kr',
    features: ['Flexibla villkor', 'Inga dolda avgifter', 'Upp till 15 års löptid', 'Jämför utan att påverka UC'],
    rating: 4.6,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: '3',
    provider: 'Marginalen Bank',
    logo: '/placeholder.svg',
    rate: '5.95%',
    amount: '20 000 - 600 000 kr',
    features: ['Svar direkt', 'Ingen uppläggningsavgift', 'Flexibel återbetalning', 'Konkurrenskraftiga räntor'],
    rating: 4.7,
    link: '#',
    product_type: 'private_loan'
  },
];

export const topCreditCards: Product[] = [
  {
    id: 'cc1',
    provider: 'Premium Cashback',
    logo: '/placeholder.svg',
    rate: '8,95%',
    cashback: 'Upp till 25% rabatt',
    amount: 'Kredit upp till 120 000 kr',
    features: ['Rabatt i 300+ onlinebutiker', 'Ingen årsavgift', '56 dagar räntefritt', 'Apple Pay & Google Pay'],
    rating: 4.8,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc2',
    provider: 'Flex Rewards',
    logo: '/placeholder.svg',
    rate: '9,90%',
    cashback: 'CashPoints eller cashback',
    amount: 'Kredit upp till 150 000 kr',
    features: ['Välj mellan CashPoints eller cashback', 'Ingen årsavgift', '45 dagar räntefritt', 'Inga uttagsavgifter'],
    rating: 4.7,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc3',
    provider: 'Gold Bonus',
    logo: '/placeholder.svg',
    rate: '10,50%',
    cashback: '10 000 välkomstpoäng',
    amount: 'Kredit upp till 150 000 kr',
    features: ['Bonuspoäng på alla köp', '60 dagar räntefritt', 'Förlängd garanti', 'Reseförsäkring ingår'],
    rating: 4.6,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc4',
    provider: 'Travel Plus',
    logo: '/placeholder.svg',
    rate: '11,20%',
    cashback: 'Ingen valutapåslag',
    amount: 'Kredit upp till 80 000 kr',
    features: ['0% valutaväxling', 'Reseförsäkring världen över', '56 dagar räntefritt', 'Gratis extrakort'],
    rating: 4.5,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc5',
    provider: 'Premium Lounge',
    logo: '/placeholder.svg',
    rate: '12,95%',
    cashback: 'Lounge Access',
    amount: 'Kredit upp till 200 000 kr',
    features: ['Tillgång till 1200+ flygplatslounger', 'Fast Track säkerhetskontroll', 'Concierge service 24/7', 'Reseförsäkring Premium'],
    rating: 4.9,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc6',
    provider: 'Smart Savings',
    logo: '/placeholder.svg',
    rate: '9,50%',
    cashback: 'Ingen årsavgift första året',
    amount: 'Kredit upp till 50 000 kr',
    features: ['0 kr årsavgift första året', 'Ingen valutapåslag', 'Allriskförsäkring', 'Apple Pay & Google Pay'],
    rating: 4.4,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc7',
    provider: 'Flygpoäng Premium',
    logo: '/placeholder.svg',
    rate: '11,90%',
    cashback: 'Tjäna flygpoäng',
    amount: 'Kredit upp till 180 000 kr',
    features: ['1 poäng per 10 kr', 'Bonuspoäng på flygresor', 'Reseförsäkring', 'Fast Track'],
    rating: 4.7,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc8',
    provider: 'Family Card',
    logo: '/placeholder.svg',
    rate: '10,20%',
    cashback: 'Upp till 5% på matvaror',
    amount: 'Kredit upp till 100 000 kr',
    features: ['Rabatt på matinköp', 'Gratis extrakort till familjen', 'Försäkring för hela familjen', 'Ingen årsavgift'],
    rating: 4.5,
    link: '#',
    product_type: 'credit_card'
  },
  {
    id: 'cc9',
    provider: 'Flexible Payment',
    logo: '/placeholder.svg',
    rate: '9,75%',
    cashback: 'Räntefri delbetalning',
    amount: 'Kredit upp till 75 000 kr',
    features: ['Räntefri delbetalning upp till 24 mån', 'Fast låg månadsavgift', 'Ingen uppläggningsavgift', 'Prisgaranti'],
    rating: 4.6,
    link: '#',
    product_type: 'credit_card'
  },
];

export const topSavings: Product[] = [
  {
    id: 's1',
    provider: 'Northmill',
    logo: '/placeholder.svg',
    rate: '3.75%',
    rates: [
      { period: 'Ingen', rate: '2.50%' },
      { period: '1 år', rate: '3.00%' },
      { period: '2 år', rate: '3.50%' },
      { period: '3 år', rate: '3.75%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Ingen minsta insättning',
    features: ['Högsta räntan på marknaden', 'Insättningsgaranti', 'Inga avgifter', 'Mobil app', 'Fri insättning och uttag'],
    rating: 4.9,
    link: '#',
    product_type: 'savings'
  },
  {
    id: 's2',
    provider: 'Resurs Bank',
    logo: '/placeholder.svg',
    rate: '3.60%',
    rates: [
      { period: 'Ingen', rate: '2.25%' },
      { period: '1 år', rate: '2.95%' },
      { period: '2 år', rate: '3.35%' },
      { period: '3 år', rate: '3.60%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Från 0 kr',
    features: ['Konkurrenskraftig ränta', 'Insättningsgaranti', 'Fri insättning och uttag', 'Enkel hantering online', 'Mobil app'],
    rating: 4.7,
    link: '#',
    product_type: 'savings'
  },
  {
    id: 's3',
    provider: 'Santander',
    logo: '/placeholder.svg',
    rate: '3.55%',
    rates: [
      { period: 'Ingen', rate: '2.30%' },
      { period: '1 år', rate: '2.90%' },
      { period: '2 år', rate: '3.30%' },
      { period: '3 år', rate: '3.55%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Från 0 kr',
    features: ['Flexibel insättning', 'Insättningsgaranti', 'Mobil app', 'Snabb överföring', 'Inga avgifter'],
    rating: 4.6,
    link: '#',
    product_type: 'savings'
  },
  {
    id: 's4',
    provider: 'Avanza',
    logo: '/placeholder.svg',
    rate: '3.40%',
    rates: [
      { period: 'Ingen', rate: '2.75%' },
      { period: '1 år', rate: '3.00%' },
      { period: '2 år', rate: '3.20%' },
      { period: '3 år', rate: '3.40%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Från 0 kr',
    features: ['Populärt sparkonto', 'Insättningsgaranti', 'Ingen bindningstid', 'Mobil app', 'Direkt tillgång till pengarna'],
    rating: 4.8,
    link: '#',
    product_type: 'savings'
  },
  {
    id: 's5',
    provider: 'Nordea',
    logo: '/placeholder.svg',
    rate: '3.20%',
    rates: [
      { period: 'Ingen', rate: '2.10%' },
      { period: '1 år', rate: '2.60%' },
      { period: '2 år', rate: '3.00%' },
      { period: '3 år', rate: '3.20%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Från 0 kr',
    features: ['Trygg storbank', 'Insättningsgaranti', 'Personlig rådgivning', 'Mobil app', 'Bred tillgänglighet'],
    rating: 4.5,
    link: '#',
    product_type: 'savings'
  },
  {
    id: 's6',
    provider: 'Swedbank',
    logo: '/placeholder.svg',
    rate: '3.15%',
    rates: [
      { period: 'Ingen', rate: '2.05%' },
      { period: '1 år', rate: '2.55%' },
      { period: '2 år', rate: '2.95%' },
      { period: '3 år', rate: '3.15%' },
    ],
    minDeposit: '0 kr',
    withdrawalTerms: 'När som helst',
    amount: 'Från 0 kr',
    features: ['Välkänd bank', 'Insättningsgaranti', 'Bra kundservice', 'Mobil app', 'Lokal närvaro'],
    rating: 4.4,
    link: '#',
    product_type: 'savings'
  },
];

export const topBusinessLoans: Product[] = [
  {
    id: 'b1',
    provider: 'Svensk Fakturaköp',
    logo: '/placeholder.svg',
    rate: '5.95%',
    amount: '50 000 - 5 000 000 kr',
    features: ['Fakturabelåning', 'Snabba utbetalningar', 'Ingen UC', 'Flexibel kredit'],
    rating: 4.6,
    link: '#',
    product_type: 'business_loan'
  },
  {
    id: 'b2',
    provider: 'Collector Business',
    logo: '/placeholder.svg',
    rate: '6.45%',
    amount: '25 000 - 3 000 000 kr',
    features: ['För nystartade företag', 'Digital process', 'Snabba beslut', 'Utan säkerhet'],
    rating: 4.5,
    link: '#',
    product_type: 'business_loan'
  },
  {
    id: 'b3',
    provider: 'Qred',
    logo: '/placeholder.svg',
    rate: '6.95%',
    amount: '20 000 - 2 000 000 kr',
    features: ['Svar inom 1 timme', 'Flexibel återbetalning', 'Inga dolda avgifter', 'Personlig service'],
    rating: 4.7,
    link: '#',
    product_type: 'business_loan'
  },
];

export const topMortgages: Product[] = [
  {
    id: 'm1',
    provider: 'Ordna Bolån',
    logo: ordna_bolan,
    rate: '2,59%',
    amount: '500 000 - 15 000 000 kr',
    features: [
      'Personlig rådgivning',
      'Jämför flera banker på en ansökan',
      'Endast en UC‑förfrågan',
      'Hög kundnöjdhet'
    ],
    rating: 4.8,
    link: 'https://go.adt256.com/t/t?a=1137286168&as=2024680921&t=2&tk=1',
    product_type: 'private_loan'
  },
  {
    id: 'm2',
    provider: 'SBAB',
    logo: '/placeholder.svg',
    rate: '2.55%',
    amount: '300 000 - 15 000 000 kr',
    features: ['Konkurrenskraftiga räntor', 'Digital bolåneprocess', 'Personlig rådgivning', 'Belåningsgrad upp till 85%'],
    rating: 4.7,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: 'm3',
    provider: 'Länsförsäkringar',
    logo: '/placeholder.svg',
    rate: '2.65%',
    amount: '200 000 - 18 000 000 kr',
    features: ['Bra ränterabatter', 'Upp till 10 års bindningstid', 'Rabatt vid samlade krediter', 'Lokal rådgivning'],
    rating: 4.6,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: 'm4',
    provider: 'Nordea',
    logo: '/placeholder.svg',
    rate: '2.70%',
    amount: '400 000 - 25 000 000 kr',
    features: ['Flexibla bolånepaket', 'Bonusprogram för lojala kunder', 'Digital signeringslösning', 'Rörlig eller bunden ränta'],
    rating: 4.5,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: 'm5',
    provider: 'Handelsbanken',
    logo: '/placeholder.svg',
    rate: '2.75%',
    amount: '300 000 - 22 000 000 kr',
    features: ['Personlig bolånerådgivare', 'Hög belåningsgrad möjlig', 'Omförhandlingsfria villkor', 'Snabb hantering'],
    rating: 4.6,
    link: '#',
    product_type: 'private_loan'
  },
  {
    id: 'm6',
    provider: 'SEB',
    logo: '/placeholder.svg',
    rate: '2.80%',
    amount: '250 000 - 20 000 000 kr',
    features: ['Konkurrenskraftiga villkor', 'Digitalt lånelöfte', 'Rabatt vid samlade affärer', 'Betala av i förtid utan avgift'],
    rating: 4.4,
    link: '#',
    product_type: 'private_loan'
  },
];
